import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import { MsalProvider } from "@azure/msal-react";
// import { msalInstance } from "./Authentication/Msal_Authentication/msalInstance";
import { Provider } from "react-redux";
import store from "./Store/Index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = async () => {
  // await msalInstance.initialize();

  root.render(
    // <MsalProvider instance={msalInstance}>
    //   <Provider store={store}>
    //     <App />
    //     <ToastContainer
    //       position="top-right"
    //       autoClose={2500}
    //       hideProgressBar
    //       closeOnClick
    //       pauseOnHover
    //       draggable={false}
    //       newestOnTop
    //       theme="light"
    //       style={{ zIndex: 99999 }}
    //     />
    //   </Provider>
    // </MsalProvider>,
    <Provider store={store}>
      <App />

      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable={false}
        newestOnTop
        theme="light"
        style={{ zIndex: 99999 }}
      />
    </Provider>,
  );
};

renderApp();
